import { useState } from "react";
import { useDispatch } from "react-redux";
import Lightbox from "yet-another-react-lightbox";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@/shared/components/Button/Button";

import { setIsVisibleModalDialog } from "@/store/ui/ui";

import formattedDate from "@/utils/formattedDate";
import { PhotoAdress } from "@/utils/constants";

import { IPatientDetailsPageItem } from "@/shared/interfaces/patientPage";
import { setPatientId } from "@/store/patients/patients";

export default function PatientDetailsPageItem({
    photoData,
}: {
    photoData: IPatientDetailsPageItem;
}) {
    const [open, setOpen] = useState(false);
    const { _id, title, description, filePath, uploadedAt } = photoData;
    const newArr = filePath.map(item => ({
        src: PhotoAdress + item,
    }));
    const dispatch = useDispatch();

    return (
        <>
            <Accordion
                sx={{
                    backgroundColor: "#F6F9F9",
                    border: "1px solid #DCE0E5",
                    boxShadow: "none",
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls='panel1-content'
                    id={`panel1-header-${_id}`}
                >
                    <div className='stat_listing_item_title_container'>
                        <p
                            className='stat_listing_item_title'
                            id='photos_title_container'
                        >
                            {title ? title : "Пацієнта видалено з бази"}
                            <span className='photos_title_span'>
                                {uploadedAt
                                    ? formattedDate(uploadedAt)
                                    : "Дані відсутні"}
                            </span>
                        </p>
                        <p className='stat_listing_item_doctor_name'>
                            {description ? description : "Примітки відсутні"}
                        </p>
                        <div
                            className='stat_listing_item_payment_container'
                            id='photos_total_container'
                        >
                            <p
                                className='stat_listing_item_total'
                                id='photos_total_container'
                            >
                                Кількість фото:
                                <span>{filePath.length}</span>
                            </p>
                        </div>
                    </div>
                </AccordionSummary>
                <AccordionDetails>
                    <div className='photos_container'>
                        {filePath.map((item: string, photoIdx: number) => {
                            const url = PhotoAdress + item;
                            return (
                                <img
                                    key={photoIdx}
                                    src={url}
                                    loading='lazy'
                                    onError={e => {
                                        (e.target as HTMLImageElement).onerror =
                                            null;
                                        (e.target as HTMLImageElement).src =
                                            "/patients/no_photo.jpg";
                                    }}
                                    alt='Фото пацієнта'
                                    className='photo_item'
                                    onClick={() => setOpen(true)}
                                />
                            );
                        })}
                    </div>
                    <Button
                        id={_id}
                        variant={"delete-small"}
                        text={"Видалити фото"}
                        style={{ marginTop: 20 }}
                        onClick={() => {
                            dispatch(setIsVisibleModalDialog(true));
                            dispatch(setPatientId(_id));
                        }}
                    />
                </AccordionDetails>
            </Accordion>
            <Lightbox
                open={open}
                close={() => setOpen(false)}
                slides={newArr}
            />
        </>
    );
}
